var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row col-12" }, [
    _c("div", { staticClass: "col-8" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", {}, [
          _c(
            "a",
            {
              staticClass: "font-medium-3 text-dark",
              attrs: { href: "question/" + _vm.question.slug },
            },
            [_vm._v(_vm._s(_vm.question.title))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "font-small-1 text-muted" }, [
            _c("div", { staticClass: "avatar avatar-sm" }, [
              _c("img", {
                staticClass: "img holder",
                attrs: {
                  src:
                    _vm.question.owner.avatar === null
                      ? "/images/avatar.png"
                      : _vm.question.owner.avatar.url,
                },
              }),
            ]),
            _vm._v(
              " " +
                _vm._s(_vm.question.owner.first_name) +
                " " +
                _vm._s(_vm.question.owner.last_name) +
                " " +
                _vm._s(_vm.__("globals.asked")) +
                " "
            ),
            _c("span", {
              domProps: {
                textContent: _vm._s(_vm.ago(_vm.question.published_at)),
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-auto" },
          _vm._l(_vm.question.tags, function (tag) {
            return _c("span", { key: tag.id, staticClass: "question-tag" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(tag.name) +
                  "\n                "
              ),
            ])
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-4 p-2" }, [
          _c(
            "div",
            {
              staticClass: "text-center",
              staticStyle: {
                "font-size": "17px",
                "font-weight": "300",
                "margin-bottom": "4px",
              },
            },
            [_c("span", [_vm._v(_vm._s(_vm.question.votesCount))])]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm.question.votesCount === 1
                    ? _vm.__("globals.vote")
                    : _vm.__("globals.votes")
                ) +
                "\n                "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 p-2" }, [
          _c(
            "div",
            {
              staticClass: "text-center",
              staticStyle: {
                "font-size": "17px",
                "font-weight": "300",
                "margin-bottom": "4px",
              },
            },
            [
              _c("span", {
                attrs: { title: _vm.question.answersCount + " answer" },
                domProps: { textContent: _vm._s(_vm.question.answersCount) },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm.question.answersCount === 1
                    ? _vm.__("globals.answer")
                    : _vm.__("globals.answers")
                ) +
                "\n                "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-4 p-2" }, [
          _c(
            "div",
            {
              staticClass: "text-center",
              staticStyle: {
                "font-size": "17px",
                "font-weight": "300",
                "margin-bottom": "4px",
              },
            },
            [_c("span", [_vm._v(_vm._s(_vm.question.views))])]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm.question.views === 1
                    ? _vm.__("globals.view")
                    : _vm.__("globals.views")
                ) +
                "\n                "
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }